// src/services/api/offlineSales/settings.js
import { apiClient } from '../base';

export const getSettings = async () => {
  const response = await apiClient.get('/offline-sales/settings');
  return response.data;
};

export const updateSettings = async (data) => {
  const response = await apiClient.put('/offline-sales/settings', data);
  return response.data;
};
